import "./education.css";


const About = () => {
  return (
    <div className="a">
      
        <h1 className="a-title">Education</h1>
        <p>
									<ul>
										<li>
											<h3>B.Tech in Electronics and Telecommunication </h3>
											<h4><a href="https://www.iiit-bh.ac.in/" target="_blank">IIIT Bhubaneswar</a></h4>
											<div class="exp-flex">
												<div>July, 2019 - July 2023</div>
												<div>CGPA: 7.75</div>
											</div>
										</li> <br/>
										<li>
											<h3>12 th in Science</h3>
											<h4><a href="http://lrdavctc.org/" target="_blank">LR DAV Public School,Gandarpur</a></h4>
											<div class="exp-flex">
												<div>March, 2016 - March, 2018</div>
												<div>Percentage: 87.2%</div>
											</div>
										</li> <br/>
										<li>
											<h3>CBSE 10th</h3>
											<h4><a href="http://lrdavctc.org/" target="_blank">LR DAV Public School,Gandarpur</a></h4>
											<div class="exp-flex">
												<div>March, 2015 - March, 2016</div>
												<div>CGPA: 10</div>
											</div>
										</li> <br/>
									</ul>
								</p>
                                <div className="c-bg"></div>
      </div>
   
  );
};

export default About;
